export default __webpack_public_path__ + "f97f8a1fd9134155ef8d665ee01b3fa3.svg";